import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FloatingInputComponent } from '@shared/components/ui/floating-input';
import { HorusBtnDirective } from '../../../../shared/directives/horus-btn.directive';
import { MicrosoftButtonComponent } from '@shared/components/ui/microsoft-button/microsoft-button.component';
import { AuthState } from '../../services/auth.state';
import { HorusLoadingComponent } from '@shared/components/domain/horus-loading/horus-loading.component';
import { SmallLogoComponent } from '@shared/components/ui';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FloatingInputComponent,
    HorusBtnDirective,
    MicrosoftButtonComponent,
    HorusLoadingComponent,
    SmallLogoComponent,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  readonly authState = inject(AuthState);
  private readonly fb = inject(FormBuilder);
  private isMicrosoftLoginInProgress = false;

  readonly loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
  });

  constructor() {
    this.authState.resetAllMutations();
  }

  onMicrosoftLogin(): void {
    if (this.isMicrosoftLoginInProgress) {
      return;
    }
    
    this.isMicrosoftLoginInProgress = true;
    this.authState.loginWithMicrosoft();
    
    setTimeout(() => {
      this.isMicrosoftLoginInProgress = false;
    }, 3000);
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    const { email, password } = this.loginForm.value;
    this.authState.login(email, password);
  }

  get emailInvalid(): boolean {
    const email = this.loginForm.get('email');
    return !!(email?.invalid && email?.touched);
  }

  get passwordInvalid(): boolean {
    const password = this.loginForm.get('password');
    return !!(password?.invalid && password?.touched);
  }
}
